(function () {
  const moneyFormat = window.BananaProtect?.moneyFormat || '{{amount}}';
  function formatMoney(cents) {
    const value = (Number(cents || 0) / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function openDrawer() { document.body.classList.add('drawer-open'); }
  function closeDrawer() { document.body.classList.remove('drawer-open'); }

  function renderCart(cart) {
    qsa('[data-cart-count]').forEach(el => { el.textContent = cart.item_count || 0; });
    const itemsTarget = qs('[data-cart-items]');
    const subtotalTarget = qs('[data-cart-subtotal]');
    if (subtotalTarget) subtotalTarget.textContent = formatMoney(cart.total_price || 0);
    if (!itemsTarget) return;
    if (!cart.items || !cart.items.length) {
      itemsTarget.innerHTML = '<div class="empty-state"><h3>Din kurv er tom</h3><p>Tilføj BananaProtect, og hold dine bananer friske længere.</p><a class="button" href="/collections/all">Køb nu</a></div>';
      return;
    }
    itemsTarget.innerHTML = cart.items.map(item => {
      const image = item.image ? `<img src="${item.image}" alt="${item.product_title.replace(/"/g,'&quot;')}">` : '<div class="drawer-item__placeholder"></div>';
      return `<div class="drawer-item" data-line-key="${item.key}">${image}<div><div class="drawer-item__title">${item.product_title}</div><div class="drawer-item__meta">Antal ${item.quantity} · ${formatMoney(item.final_line_price)}</div></div><button class="icon-button" data-remove-line="${item.key}" aria-label="Fjern">×</button></div>`;
    }).join('');
  }

  function fetchCart(openAfter = false) {
    return fetch(window.BananaProtect.routes.cart, { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => { renderCart(cart); if (openAfter) openDrawer(); return cart; });
  }

  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-open-cart]');
    if (openBtn) { e.preventDefault(); fetchCart(true); }
    if (e.target.closest('[data-close-cart]') || e.target.classList.contains('drawer-overlay')) closeDrawer();

    const searchOpen = e.target.closest('[data-open-search]');
    if (searchOpen) { e.preventDefault(); qs('[data-search-overlay]')?.setAttribute('data-open','true'); setTimeout(() => qs('[data-search-overlay] input')?.focus(), 30); }
    if (e.target.closest('[data-close-search]') || e.target.hasAttribute('data-search-overlay')) qs('[data-search-overlay]')?.setAttribute('data-open','false');

    const menuToggle = e.target.closest('[data-mobile-toggle]');
    if (menuToggle) {
      const header = qs('.header');
      header?.setAttribute('data-mobile-open', header.getAttribute('data-mobile-open') === 'true' ? 'false' : 'true');
    }

    const remove = e.target.closest('[data-remove-line]');
    if (remove) {
      e.preventDefault();
      fetch(window.BananaProtect.routes.cartChange, {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({ id: remove.getAttribute('data-remove-line'), quantity: 0 })
      }).then(r => r.json()).then(renderCart);
    }

    const qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      const wrapper = qtyBtn.closest('.quantity');
      const input = qs('input', wrapper);
      const step = qtyBtn.getAttribute('data-qty') === 'plus' ? 1 : -1;
      input.value = Math.max(1, Number(input.value || 1) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const slide = e.target.closest('[data-slide]');
    if (slide) {
      const track = qs(slide.getAttribute('data-slide'));
      if (track) track.scrollBy({ left: slide.dataset.direction === 'prev' ? -360 : 360, behavior: 'smooth' });
    }
  });

  const header = qs('.header');
  if (header) {
    const megaTriggers = qsa('[data-mega-trigger]', header);
    megaTriggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', () => header.setAttribute('data-menu-open','true'));
      trigger.addEventListener('focus', () => header.setAttribute('data-menu-open','true'));
    });
    header.addEventListener('mouseleave', () => header.setAttribute('data-menu-open','false'));
  }

  qsa('form.js-product-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      if (!window.fetch) return;
      e.preventDefault();
      const button = qs('[type="submit"]', form);
      const oldText = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = 'Tilføjer…'; }
      fetch(window.BananaProtect.routes.cartAdd, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(r => r.ok ? r.json() : Promise.reject(r))
        .then(() => fetchCart(true))
        .catch(() => { alert('Kunne ikke lægge varen i kurven. Prøv igen.'); })
        .finally(() => { if (button) { button.disabled = false; button.textContent = oldText; } });
    });
  });

  qsa('[data-gallery-thumb]').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = qs('[data-gallery-main]');
      const img = qs('img', btn);
      if (target && img) target.innerHTML = `<img src="${btn.dataset.full}" alt="${img.alt}">`;
    });
  });

  fetchCart(false);
})();
